<form #form="ngForm" [ngClass]="{ 'forms': !exibirCampoTelefone }">
  <div class="form-group">
    <span class="icon professional-class"></span>
    <div class="inputs">
      <label for="user-occupation-class">Classe Profissional</label>
      <select
        name="classeProfissional"
        class="form-control"
        (change)="onChangeClasse()"
        [(ngModel)]="dadosProfissionais.classeProfissional"
        appShowErrorMessages
        [disabled]="isLoadingProfissao"
        required
        id="user-occupation-class"
      >
        <option [ngValue]="undefined" hidden>Selecione...</option>
        <option *ngFor="let cla of classes" [ngValue]="cla">
          {{ cla.descricao }}
        </option>
      </select>
    </div>
  </div>

  <div class="form-group">
    <span class="icon profession"></span>
    <div [ngSwitch]="isLoadingProfissao" class="inputs">
      <label for="user-occupation">Profissão</label>
      <select
        *ngSwitchDefault
        appShowErrorMessages
        id="user-occupation"
        name="profissao"
        class="form-control"
        (change)="onChange()"
        [(ngModel)]="dadosProfissionais.profissao"
        [disabled]="profissoes.length === 0"
        required
      >
        <option [ngValue]="undefined" hidden>Selecione ...</option>
        <option *ngFor="let pro of profissoes" [ngValue]="pro">
          {{ pro.descricao }}
        </option>
      </select>
      <app-loader-default *ngSwitchCase="true"></app-loader-default>
    </div>
  </div>

  <div
    *ngIf="dadosProfissionais?.classeProfissional?.empresa"
    class="form-group"
  >
    <span class="icon company"></span>
    <div class="inputs">
      <label for="user-work-company">Empresa</label>
      <input
        type="text"
        class="form-control"
        id="user-work-company"
        placeholder="Digite o nome da empresa"
        appShowErrorMessages
        uppercase
        [appNomeEmpresa]="true"
        requiredMessage="Nome da empresa é obrigatório"
        maxlength="40"
        minlength="3"
        name="empresaCliente"
        [(ngModel)]="dadosProfissionais.empresa.nome"
        (ngModelChange)="onChange()"
        required
      />
    </div>
  </div>

  <div
    *ngIf="
      exibirCampoTelefone && dadosProfissionais?.classeProfissional?.empresa
    "
    class="form-group"
  >
    <span class="icon company-phone"></span>
    <div class="inputs">
      <label for="user-work-company-phone">Telefone da empresa</label>
      <input
        type="text"
        class="form-control"
        placeholder="(00) 00000-0000"
        appTelefone
        minlength="10"
        name="foneEmpresaCliente"
        [(ngModel)]="dadosProfissionais.empresa.telefone"
        (ngModelChange)="onChange()"
        appShowErrorMessages
        invalidMessage="Telefone inválido"
        required
      />
    </div>
  </div>
</form>
